import { ALERT } from '@flexo/reducers';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../button/button';
import styles from './../alert.module.scss';
// Note: date picker intentionally not implemented, keep only label/space in UI
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export default function AlertUpdateUserRemoval() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const alertState = useSelector((state: any) => state.alert);

  const content = t('alerts.update_user_removal', {
    returnObjects: true,
  }) as any;

  async function onReschedule() {
    try {
      if (alertState?.alert?.callback) {
        await alertState.alert.callback();
      }
    } finally {
      dispatch(ALERT.ResetAlert({} as any));
    }
  }

  function onReinstate() {
    try {
      if (alertState?.alert?.dismissCallback) {
        (alertState.alert as any).dismissCallback();
      }
    } finally {
      dispatch(ALERT.ResetAlert({} as any));
    }
  }

  return (
    <div>
      <div
        id="alert-update-user-removal"
        className={`${styles.Alert} ${styles.Alert__Confirm__Credentials__Changes}`}
      >
        <div className={styles.Alert__Title}>
          <div>{content.title}</div>
          <div className={styles.Alert__Title__Close}></div>
        </div>

        <div className={styles.Alert__Content}>{content.description}</div>

        <div className={`heading4 ${styles.Alert__Content__Label} mt-1`}>
          {content.dateLabel}
        </div>

        {/* Placeholder block to reserve space for datepicker (not implemented) */}
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <div
            style={{
              backgroundColor: 'var(--hive-greyscale-100)',
              height: 48,
              borderRadius: 8,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              padding: '0 16px',
              marginBottom: 8,
            }}
          >
            <span style={{ color: 'var(--hive-greyscale-700)' }}>
              {content.datePlaceholder}
            </span>
          </div>
        </LocalizationProvider>

        <div className={styles.Alert__Footer__Actions}>
          <Button
            variant="secondary"
            color="secondary"
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Back}`}
            label={content.reinstate}
            onClick={onReinstate}
          />
          <Button
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Confirm}`}
            variant="primary"
            color="grey"
            label={content.reschedule}
            onClick={onReschedule}
          />
        </div>
      </div>
    </div>
  );
}
